import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useLanguage } from "../../context/LanguageContext";
import Logo from "../../assets/logo.png";

const Header = () => {
  const { user, logout } = useAuth();
  const { lang, setAlbanian, setEnglish } = useLanguage();

  const navigate = useNavigate();
  const location = useLocation();

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const menuLabels = {
    en: {
      home: "Home",
      shop: "Shop",
      repair: "Repair",
      parts: "Electronic Parts",
      service: "IT Services",
      contact: "Contact",
      login: "Login",
      logout: "Logout",
    },
    sq: {
      home: "Kryefaqja",
      shop: "Dyqani",
      repair: "Riparime",
      parts: "Komponente Elektronike",
      service: "Sherbime IT",
      contact: "Kontakti",
      login: "Hyr",
      logout: "Dil",
    },
  };

  const labels = lang === "sq" ? menuLabels.sq : menuLabels.en;

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between">

        {/* Logo */}
        <Link to="/" className="flex items-center space-x-2">
          <img
            src={Logo}
            alt="Masterphone Logo"
            className="h-10 w-auto"
          />

          <span className="hidden sm:block text-2xl font-bold bg-gradient-to-r from-purple-800 via-green-800 to-orange-800 bg-clip-text text-transparent">
            Master Sol&Tech
          </span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-5 font-nunito text-black text-lg">

          <Link to="/" className="hover:text-blue-500 font-semibold">
            {labels.home}
          </Link>

          <Link to="/shop" className="hover:text-blue-500 font-semibold">
            {labels.shop}
          </Link>

          <Link to="/repair" className="hover:text-blue-500 font-semibold">
            {labels.repair}
          </Link>

          <Link to="/parts" className="hover:text-blue-500 font-semibold">
            {labels.parts}
          </Link>

          <Link to="/service" className="hover:text-blue-500 font-semibold">
            {labels.service}
          </Link>

          <Link to="/contact" className="hover:text-blue-500 font-semibold">
            {labels.contact}
          </Link>

          {/* Language Switcher */}
          <div className="flex items-center gap-2 text-xl">
            <button
              onClick={setAlbanian}
              className={lang === "sq" ? "opacity-70" : ""}
            >
              🇦🇱
            </button>

            <button
              onClick={setEnglish}
              className={lang === "en" ? "opacity-70" : ""}
            >
              🇬🇧
            </button>
          </div>

          {/* Login */}
          {location.pathname === "/login" && !user && (
            <Link
              to="/login"
              className="hover:text-blue-500 font-semibold"
            >
              {labels.login}
            </Link>
          )}

          {/* Logout */}
          {user && (
            <button
              onClick={handleLogout}
              className="hover:text-blue-500 font-semibold"
            >
              {labels.logout}
            </button>
          )}
        </nav>

        {/* Mobile Hamburger Button */}
        <button
          className="md:hidden text-3xl"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t shadow-lg">

          <div className="flex flex-col items-center py-5 space-y-4 text-lg">

            <Link
              to="/"
              onClick={() => setMobileMenuOpen(false)}
            >
              {labels.home}
            </Link>

            <Link
              to="/shop"
              onClick={() => setMobileMenuOpen(false)}
            >
              {labels.shop}
            </Link>

            <Link
              to="/repair"
              onClick={() => setMobileMenuOpen(false)}
            >
              {labels.repair}
            </Link>

            <Link
              to="/parts"
              onClick={() => setMobileMenuOpen(false)}
            >
              {labels.parts}
            </Link>

            <Link
              to="/service"
              onClick={() => setMobileMenuOpen(false)}
            >
              {labels.service}
            </Link>

            <Link
              to="/contact"
              onClick={() => setMobileMenuOpen(false)}
            >
              {labels.contact}
            </Link>

            {/* Languages */}
            <div className="flex gap-4 text-2xl">
              <button onClick={setAlbanian}>🇦🇱</button>
              <button onClick={setEnglish}>🇬🇧</button>
            </div>

            {/* Login */}
            {location.pathname === "/login" && !user && (
              <Link
                to="/login"
                onClick={() => setMobileMenuOpen(false)}
              >
                {labels.login}
              </Link>
            )}

            {/* Logout */}
            {user && (
              <button
                onClick={() => {
                  handleLogout();
                  setMobileMenuOpen(false);
                }}
              >
                {labels.logout}
              </button>
            )}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;